/* eslint-disable */

<template>
	<v-card class="mt-10">
		<v-card-text>
			<div class="d-flex flex-column">
				<v-alert> Procedere con la sincronizzazione manuale da Idempiere a Mastercal?<br/>
				<b>Durante l'esecuzione non abbandonare la pagina!</b>
				</v-alert>
			</div>
			<div v-if="syncronizing_id">
				<v-progress-linear
				v-if="sync_running_id"
				color="deep-purple accent-4"
				indeterminate
				rounded
				height="6"
				></v-progress-linear>
				<div v-else>
					Sincronizzazione effettuata.
				</div>
			</div>
		</v-card-text>
		<v-card-actions class="d-flex align-center justify-center">
			<div v-if="!syncronizing_id">
				<v-btn class="ma-2 pa-2" color="primary" @click="synchronize_idempiere">Procedi</v-btn>
				<v-btn class="ma-2 pa-2" text to="login">annulla</v-btn>
			</div>
			<div v-else-if="syncronizing_id && !sync_running_id">
				<v-btn class="ma-2 pa-2" color="primary" @click="reload">ricarica la pagina</v-btn>
			</div>
		</v-card-actions>
	</v-card>
	
</template>


<script>
export default {
	data() {
		return {
		syncronizing_id: false,
		sync_running_id: false,
		}
	},
	mounted() {
		this.syncronizing_id = false
		this.sync_running_id = false
	},
	beforeRouteEnter(to, from, next){
		console.log("BEFORE ROUTE LEAVE", to, from, next)
		if (from.name == 'login') {
			next('home')
		}
		next()
	},
	methods: {
		reload() {
				window.location.href='/'
		},
		async synchronize_idempiere(){
			this.syncronizing_id = true
			this.sync_running_id = true
			let res = await this.axios.get("/mastercal/system/synchronize_idempiere").catch(error => {
				console.log("error status", error);
				this.errorMessage = "errore di connessione al server - riprovare. Se il problema persiste contattare l'amministratore"
			});
			if (res && res.data){
				console.log(res)
			}
			this.sync_running_id = false
		},
		cancel(){
			this.$router.push("/")
		},
	}
}
</script>
